export interface MetricViewEntry {
  visible: boolean
  passing_threshold?: number
}

export type MetricViews = Record<string, MetricViewEntry>

export function isMetricViewEntry(value: unknown): value is MetricViewEntry {
  return (
    !!value &&
    typeof value === "object" &&
    !Array.isArray(value) &&
    typeof (value as { visible?: unknown }).visible === "boolean" &&
    (typeof (value as { passing_threshold?: unknown }).passing_threshold ===
      "number" ||
      (value as { passing_threshold?: unknown }).passing_threshold ===
        undefined)
  )
}

export function normalizeMetricConfig(
  value: unknown,
): MetricViews | null | undefined {
  if (value == null) {
    return value
  }
  if (typeof value !== "object" || Array.isArray(value)) {
    return undefined
  }

  const entries = Object.entries(value)
  if (!entries.every(([, entry]) => isMetricViewEntry(entry))) {
    return undefined
  }

  return Object.fromEntries(entries) as MetricViews
}
